import { YearButtonListWrapper } from './styles';
import { YearButtonItem } from './YearButtonItem';
import { useYearSelection, type SelectionMode } from './useYearSelection';

type YearButtonListProps = {
  years: number[];
  selectedYears: number[];
  disabled?: boolean;
  selectionMode?: SelectionMode;
  onYearClick: (year: number | null) => void;
};

export const YearButtonList = ({
  years,
  selectedYears,
  disabled,
  selectionMode = 'range',
  onYearClick,
}: YearButtonListProps) => {
  const { isSelected, isInRange, handleYearClick } = useYearSelection({
    selectedYears,
    selectionMode,
    onSelectionChange: (years) => {
      if (years.length > 0) {
        onYearClick(years[years.length - 1]);
      } else if (selectionMode === 'single') {
        onYearClick(null);
      }
    },
  });

  const currentYear = new Date().getFullYear();

  return (
    <YearButtonListWrapper>
      {years.map((year) => (
        <YearButtonItem
          key={year}
          year={year}
          isSelected={isSelected(year)}
          isInRange={isInRange(year)}
          isDisabled={disabled}
          isUnderlined={currentYear === year}
          onClick={(year) => {
            if (selectionMode === 'single') handleYearClick(year);
            else onYearClick(year);
          }}
        />
      ))}
    </YearButtonListWrapper>
  );
};
